import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class CareProductsSlider extends BaseComponent {
  constructor(options) {
    super(options);
  }
  onInit() {
    this.splide = new Splide(this.element.querySelector('.u-care-products-slider__slider'), {
        arrows: true,
        pagination: false,
        perPage: 3,
        perMove: 1,
        gap: '1rem',
        breakpoints: {
            767: {
                destroy: true,
		    },
            1023: {
                arrows: true,
                perPage: 2,
                perMove: 1,
            }
        },
    } );

    // this.splide.on('mounted', () => {
    //   const pagination = this.element.querySelector('.splide__pagination');

    //   let paginationWrapper = document.createElement('div');
    //   paginationWrapper.classList.add('splide__pagination-wrapper');
    //   pagination.parentElement.insertBefore(paginationWrapper, pagination);
    //   paginationWrapper.appendChild(pagination);
    // });

    // this.splide.on('active', function (e) {
    //   e.slide.parentElement.style.height = 'initial';
    //   e.slide.parentElement.style.height = e.slide.querySelector('.u-link-slider__item').offsetHeight + 'px';
    // });

    this.splide.mount();
  }
}

export default {
  name: 'CareProductsSlider',
  definition: CareProductsSlider
};